import * as React from "react";
import { Chip, ChipSize } from "../../../ui";
import { PartOrderItemV2 } from "../../../../generated/nest-graphql";
import { isCollected } from "../../partsStatus.utils";
import { chipStyle, stateColors } from "../partStatusChip.utils";

export const ItemStatusChip: React.FC<{ item: PartOrderItemV2 }> = ({ item }) => {
  const collected = isCollected(item);
  const label = collected ? "Picked up" : "Not picked up";

  // Individual parts stay quiet — every uncollected row shouting in orange would
  // drown out the order-level chip that actually drives the errand.
  return (
    <Chip
      size={ChipSize.SMALL}
      style={{
        ...chipStyle,
        ...(collected ? stateColors.COLLECTED : stateColors.EMPTY),
      }}
      label={label}
      aria-label={`Part status: ${label}`}
    />
  );
};
